var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50631 7.76325C7.41068 5.23103 11.3413 3.54844 13.315 2.73213C18.9326 0.416484 20.1135 0.0166593 20.8726 0C21.0413 0 21.4125 0.0333189 21.6655 0.233231C21.8679 0.399824 21.9185 0.616396 21.9523 0.78299C21.986 0.949583 22.0198 1.29943 21.986 1.56598C21.6824 4.73125 20.3665 12.4112 19.6918 15.943C19.405 17.4423 18.8483 17.9421 18.3084 17.9921C17.1276 18.092 16.2335 17.2258 15.1032 16.4927C13.315 15.3433 12.3197 14.6269 10.5822 13.4941C8.57468 12.1946 9.87364 11.4783 11.0208 10.3121C11.3244 10.0123 16.5034 5.34765 16.6046 4.93117C16.6215 4.88119 16.6215 4.68127 16.5034 4.58132C16.3853 4.48136 16.2166 4.51468 16.0817 4.548C15.8961 4.58132 13.062 6.44716 7.54563 10.1289C6.73589 10.6786 6.0105 10.9452 5.35258 10.9285C4.62719 10.9119 3.24388 10.5287 2.19797 10.1955C0.932744 9.79569 -0.0794328 9.57912 0.00491532 8.87943C0.0555242 8.51292 0.561612 8.14642 1.50631 7.76325Z",
    fill: "#4D9DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBlue);
export default __webpack_public_path__ + "static/media/telegramBlue.a7076666b64e1304416395f995ec5c3a.svg";
export { ForwardRef as ReactComponent };